// @flow
import React from 'react';
import PlaneContainer from './containers/PlaneContainer';

export type Props = $ReadOnly<{|
    planes: $ReadOnlyArray<string>
|}>;

function Planes({ planes }: Props) {
    return (
        <React.Fragment>
            {planes.map((icao) => <PlaneContainer key={icao} icao={icao} />)}
        </React.Fragment>
    )
}

export default Planes;